<template>
  <el-dialog
    :lock-scroll="false"
    :close-on-click-modal="false"
    title="新增/修改积分规则"
    :visible.sync="dialogConfigureVisible"
    width="500px"
    @close="closeConfigureDialog"
  >
    <el-form
      ref="formData"
      label-position="right"
      :model="formData"
      class="point-rule-update-form"
      :rules="rules"
    >
      <el-form-item label="规则名称" prop="integralName">
        <el-col :span="18">
          <el-input v-model.trim="formData.integralName"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="积分类型">
        <el-col :span="18">
          <el-radio-group v-model="formData.integralSence">
            <el-radio label="get">获取积分</el-radio>
            <el-radio label="use">使用积分</el-radio>
          </el-radio-group>
        </el-col>
      </el-form-item>
      <el-form-item label="积分场景" >
        <el-col :span="18">
          <el-select filterable v-model="formData.consumeType">
            <el-option
              v-for="item in consumeTypeList"
              :key="item.value"
              :value="item.value"
              :label="item.labelDefault"
            />
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="欠费是否可用">
        <el-col :span="18">
          <el-switch
            v-model="formData.arrearsUseFlag"
            active-color="#13ce66"
            inactive-color="#999999"
            active-value="y"
            inactive-value="n"
          >
          </el-switch>
        </el-col>
      </el-form-item>
      <el-form-item label="是否需要认证">
        <el-col :span="18">
          <el-switch
            v-model="formData.needUserRegisterFlag"
            active-color="#13ce66"
            inactive-color="#999999"
            active-value="y"
            inactive-value="n"
          >
          </el-switch>
        </el-col>
      </el-form-item>
      <el-form-item label="兑换率" prop="exchangeRate">
        <el-col :span="18">
          <el-input
            type="number"
            v-model.trim="formData.exchangeRate"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="备注">
        <el-col :span="18">
          <el-input type="textarea" v-model.trim="formData.attr1"></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
      <el-button @click="closeConfigureDialog">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { dictValue, pointsRuleOne } from "@/api/url";
export default {
  props: ["integralId"],
  data() {
    const valiExchangeRate = (rule, value1, callback) => {
      const value = Number(this.formData.exchangeRate);
      if (this.formData.integralSence === "get") {
        if (!value || value < 0 || value % 1 !== 0) {
          callback(new Error("兑换率必须为大于0的整数"));
        } else {
          callback();
        }
      }
      if (this.formData.integralSence === "use") {
        if (!value || value < 0) {
          callback(new Error("兑换率必须大于0"));
        } else {
          callback();
        }
      }
    };
    return {
      dialogConfigureVisible: true,
      formLabelWidth: "100px",
      formData: {
        integralName: "",
        integralSence: "get",
        consumeType: "",
        arrearsUseFlag: "n",
        needUserRegisterFlag:"y",
        exchangeRate: 1,
        attr1: "兑换率:一元换多少积分",
      },
      consumeTypeList: [],
      rules: {
        integralName: {
          required: true,
          message: "请输入积分名称",
          trigger: "blur",
        },
        exchangeRate: [
          {
            validator: valiExchangeRate,
            trigger: "blur",
            required: true,
          },
        ],

        consumeType: {
          required: true,
          message: "请选择消费类型",
          trigger: "change",
        },
      },
    };
  },
  mounted() {
    this.getConsumeType();
    if (this.integralId) {
      this.getPointsRuleDetail(this.integralId);
    }
  },

  methods: {
    getConsumeType: function() {
      this.$get(dictValue() + "integral_consume_sence").then((data) => {
        this.consumeTypeList = data?.data?.rows ?? [];
      });
    },
    addOrEditTrue: function() {
      this.dialogConfigureVisible = true;

      this.$refs["formData"].validate((valid) => {
        if (valid) {
          if (this.integralId) {
            this.$putRequest(`${pointsRuleOne()}/${this.integralId}`, {
              ...this.formData,
              integralId: this.integralId,
            }).then((res) => {
                if(res?.status!=200){
                    this.$message.error("修改失败");
                    return;
                }
                this.$message.success("修改成功");
                this.$emit("update-callback", "edit-success");

            });
          } else {
            this.$postRequest(pointsRuleOne(), {
              ...this.formData,
            }).then((res) => {
                if(res?.status!=200){
                    this.$message.error("添加失败");
                    return;
                }
                this.$message.success("添加成功");
                this.$emit("update-callback", "add-success");
            });
          }
        }
      });
    },
    closeConfigureDialog: function() {
      this.dialogConfigureVisible = true;
      this.$emit("update-callback", "cancel");
    },
    getPointsRuleDetail: function() {
      this.$get(`${pointsRuleOne()}/${this.integralId}`).then((data) => {
        if (data.status !== 200) return;
        this.formData = data?.data??{};
      });
    },
  },
};
</script>
<style>
.point-rule-update-form .el-form-item {
  display: flex;
  align-items: center;
}
.point-rule-update-form .el-form-item .el-form-item__label {
  width: 120px;
  display: inline-block;
}
.point-rule-update-form .el-form-item .el-form-item__content {
  width: calc(100% - 120px);
}
.point-rule-update-form .el-form-item .el-form-item__content .el-select {
  width: 100%;
}
</style>
